module.exports = __webpack_public_path__ + "instruct1.ecbebe50.png";